import React from "react";
import { AiOutlineArrowRight } from "react-icons/ai";
import { Container } from "react-bootstrap";
import "./DMCA.scss";

const TopComponent = () => {
  return (
    <div id="dmca" className="mb-5">
      <div style={{ backgroundColor: "rgb(255, 251, 251)" }}>
        <Container className="py-md-5 py-4 px-4 hero">
          <div>
            <h1>Legal & privacy information for our valued customers' ease</h1>

            <div className="bring-ideas">
              <p>Bring your ideas to life with professional digital assets, resource and services</p>
            </div>

            <div className="bring-ideas">
              <span>
                <a href="#">
                  Find the right product for you <AiOutlineArrowRight />
                </a>{" "}
              </span>
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
};
export default TopComponent;
